import PropTypes from 'prop-types';
import { QuestionType } from './question';

export const ImageType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  original_url: PropTypes.string.isRequired,
  internal_title: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
});

export const EventImageType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  main: PropTypes.bool.isRequired,
  order: PropTypes.number.isRequired,
  image: ImageType.isRequired,
});

export const EventTagType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  type_display: PropTypes.string.isRequired,
});

export const EventAddressType = PropTypes.shape({
  address_name: PropTypes.string.isRequired,
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string.isRequired,
  postal_code: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  lat: PropTypes.number,
  lng: PropTypes.number,
  additionalInfo: PropTypes.string,
  wheelchair_accessible: PropTypes.bool.isRequired,
});

export const EventOrganizationType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(EventImageType).isRequired,
  url: PropTypes.string.isRequired,
});

export const EventCreatedByType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
});

export const EventType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  description: PropTypes.string,
  start_at: PropTypes.string,
  end_at: PropTypes.string,
  multi_day: PropTypes.bool.isRequired,
  timezone: PropTypes.string.isRequired,
  type: PropTypes.string,
  images: PropTypes.arrayOf(EventImageType).isRequired,
  site_url: PropTypes.string,
  organization: EventOrganizationType.isRequired,
  address: EventAddressType.isRequired,
  tickets_capacity: PropTypes.number,
  tickets: PropTypes.string,
  addons: PropTypes.string,
  created_by: EventCreatedByType,
  updated_by: EventCreatedByType,
  age_tag: EventTagType,
  category_tag: EventTagType,
  whats_included_tags: PropTypes.arrayOf(EventTagType).isRequired,
  available_currencies: PropTypes.arrayOf(PropTypes.string).isRequired,
  min_ticket_price: PropTypes.number,
  max_ticket_price: PropTypes.number,
  is_virtual: PropTypes.bool.isRequired,
  virtual_platform: PropTypes.oneOf(['', 'custom', 'zoom', 'facebook_live', 'youtube']),
  how_to_participate_non_registered: PropTypes.string.isRequired,
  how_to_participate_registered: PropTypes.string.isRequired,
  cta_button_label_display: PropTypes.string.isRequired,
});

export const EventTicketType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['free', 'paid']),
  type_display: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  min_amount_per_order: PropTypes.number.isRequired,
  max_amount_per_order: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  sold_out: PropTypes.bool.isRequired,
  questions: PropTypes.arrayOf(QuestionType).isRequired, // Replace with Question type later
});

export const EventAddonType = EventTicketType;
